var _Component$defaultPro, _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { string, bool, oneOf, func, shape, object, number, oneOfType, node, arrayOf } from 'prop-types';
import { FullBleed } from "../../media/FullBleed";
import { ContactHeader } from "../../collections/ContactHeader";
import { FlexContainer } from "../../layout/FlexContainer";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { Heading } from "../../typography/Heading";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { SearchBar } from "../SearchBar";
import { ShowOn } from "../../layout/ShowOn";
import { DEFAULT_BOTTOM_OFFSET } from "./constants";
export var Component = function Component(_ref) {
  var backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      bottomOffset = _ref.bottomOffset,
      className = _ref.className,
      currencyNoResultsText = _ref.currencyNoResultsText,
      currencyOptions = _ref.currencyOptions,
      currencyValue = _ref.currencyValue,
      headerLogoHref = _ref.headerLogoHref,
      headerLogoSize = _ref.headerLogoSize,
      headerLogoSizes = _ref.headerLogoSizes,
      headerLogoSrc = _ref.headerLogoSrc,
      headerLogoSrcSet = _ref.headerLogoSrcSet,
      headerLogoSubText = _ref.headerLogoSubText,
      headerLogoText = _ref.headerLogoText,
      headerNavigationItems = _ref.headerNavigationItems,
      headerPrimaryCTA = _ref.headerPrimaryCTA,
      headingText = _ref.headingText,
      isSearchBarDateRangePickerLoading = _ref.isSearchBarDateRangePickerLoading,
      languageOptions = _ref.languageOptions,
      languageValue = _ref.languageValue,
      onChangeCurrency = _ref.onChangeCurrency,
      onChangeLanguage = _ref.onChangeLanguage,
      phoneNumber = _ref.phoneNumber,
      placeholderBackgroundImageUrl = _ref.placeholderBackgroundImageUrl,
      searchBarDateRangePickerLocaleCode = _ref.searchBarDateRangePickerLocaleCode,
      searchBarDatesCheckInLabel = _ref.searchBarDatesCheckInLabel,
      searchBarDatesCheckOutLabel = _ref.searchBarDatesCheckOutLabel,
      searchBarDatesInputFocusedInput = _ref.searchBarDatesInputFocusedInput,
      searchBarDatesInputOnFocusChange = _ref.searchBarDatesInputOnFocusChange,
      searchBarDatesInputValue = _ref.searchBarDatesInputValue,
      searchBarGetIsDayBlocked = _ref.searchBarGetIsDayBlocked,
      searchBarGuestsInputLabel = _ref.searchBarGuestsInputLabel,
      searchBarGuestsInputValue = _ref.searchBarGuestsInputValue,
      searchBarLocationInputLabel = _ref.searchBarLocationInputLabel,
      searchBarLocationInputValue = _ref.searchBarLocationInputValue,
      searchBarLocationOptions = _ref.searchBarLocationOptions,
      searchBarMaximumGuestsInputValue = _ref.searchBarMaximumGuestsInputValue,
      searchBarModalHeadingText = _ref.searchBarModalHeadingText,
      searchBarOnChangeInput = _ref.searchBarOnChangeInput,
      searchBarOnSubmit = _ref.searchBarOnSubmit,
      searchBarSearchButton = _ref.searchBarSearchButton;
  var searchBarSharedProps = {
    dateRangePickerLocaleCode: searchBarDateRangePickerLocaleCode,
    datesCheckInLabel: searchBarDatesCheckInLabel,
    datesCheckOutLabel: searchBarDatesCheckOutLabel,
    datesInputFocusedInput: searchBarDatesInputFocusedInput,
    datesInputOnFocusChange: searchBarDatesInputOnFocusChange,
    datesInputValue: searchBarDatesInputValue,
    getIsDayBlocked: searchBarGetIsDayBlocked,
    guestsInputLabel: searchBarGuestsInputLabel,
    guestsInputValue: searchBarGuestsInputValue,
    locationInputLabel: searchBarLocationInputLabel,
    locationInputValue: searchBarLocationInputValue,
    locationOptions: searchBarLocationOptions,
    maximumGuestsInputValue: searchBarMaximumGuestsInputValue,
    onChangeInput: searchBarOnChangeInput,
    onSubmit: searchBarOnSubmit,
    searchButton: searchBarSearchButton,
    isDateRangePickerLoading: isSearchBarDateRangePickerLoading
  };
  return React.createElement(FullBleed, {
    bottomOffset: bottomOffset,
    className: className,
    hasGradient: true,
    imageHeight: backgroundImageHeight,
    imageUrl: backgroundImageUrl,
    imageWidth: backgroundImageWidth,
    placeholderImageUrl: placeholderBackgroundImageUrl,
    sizes: backgroundImageSizes,
    srcSet: backgroundImageSrcSet
  }, React.createElement(ContactHeader, {
    className: className,
    currencyNoResultsText: currencyNoResultsText,
    currencyOptions: currencyOptions,
    currencyValue: currencyValue,
    isBackgroundFilled: true,
    languageOptions: languageOptions,
    languageValue: languageValue,
    logoHref: headerLogoHref,
    logoSize: headerLogoSize,
    logoSizes: headerLogoSizes,
    logoSrc: headerLogoSrc,
    logoSrcSet: headerLogoSrcSet,
    logoSubText: headerLogoSubText,
    logoText: headerLogoText,
    navigationMenuItems: headerNavigationItems,
    onChangeCurrency: onChangeCurrency,
    onChangeLanguage: onChangeLanguage,
    phoneNumber: phoneNumber,
    primaryCTA: headerPrimaryCTA
  }), React.createElement(FlexContainer, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-evenly"
  }, React.createElement(HorizontalGutters, null, React.createElement(ShowOn, {
    computer: true,
    parent: Heading,
    parentProps: {
      isColorInverted: true,
      size: 'huge',
      textAlign: 'center'
    },
    tablet: true,
    widescreen: true
  }, headingText), React.createElement(ShowOn, {
    mobile: true,
    parent: Heading,
    parentProps: {
      isColorInverted: true,
      size: 'large',
      textAlign: 'center'
    }
  }, headingText)), React.createElement(HorizontalGutters, null, React.createElement(Grid, {
    areColumnsCentered: true
  }, React.createElement(GridRow, {
    horizontalAlignContent: "center"
  }, React.createElement(ShowOn, {
    computer: true,
    parent: SearchBar,
    parentProps: _objectSpread(_objectSpread({}, searchBarSharedProps), {}, {
      willLocationDropdownOpenAbove: true
    }),
    tablet: true,
    widescreen: true
  }), React.createElement(ShowOn, {
    mobile: true
  }, React.createElement(SearchBar, _extends({}, searchBarSharedProps, {
    isDisplayedAsModal: true,
    modalHeadingText: searchBarModalHeadingText
  }))))))));
};
Component.displayName = 'ContactHomeHero';
Component.defaultProps = (_Component$defaultPro = {
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  bottomOffset: DEFAULT_BOTTOM_OFFSET,
  headingText: '',
  className: null,
  currencyNoResultsText: '',
  currencyOptions: [],
  currencyValue: null,
  headerLogoHref: '',
  headerLogoSize: 'medium',
  headerLogoSizes: undefined,
  headerLogoSrc: undefined,
  headerLogoSrcSet: undefined,
  headerLogoSubText: ''
}, _defineProperty(_Component$defaultPro, "headingText", ''), _defineProperty(_Component$defaultPro, "isHeaderBackgroundFilled", false), _defineProperty(_Component$defaultPro, "isSearchBarDateRangePickerLoading", undefined), _defineProperty(_Component$defaultPro, "languageOptions", []), _defineProperty(_Component$defaultPro, "languageValue", null), _defineProperty(_Component$defaultPro, "onChangeCurrency", undefined), _defineProperty(_Component$defaultPro, "onChangeLanguage", undefined), _defineProperty(_Component$defaultPro, "phoneNumber", ''), _defineProperty(_Component$defaultPro, "placeholderBackgroundImageUrl", null), _defineProperty(_Component$defaultPro, "headerPrimaryCTA", null), _defineProperty(_Component$defaultPro, "searchBarDateRangePickerLocaleCode", undefined), _defineProperty(_Component$defaultPro, "searchBarDatesCheckInLabel", undefined), _defineProperty(_Component$defaultPro, "searchBarDatesCheckOutLabel", undefined), _defineProperty(_Component$defaultPro, "searchBarDatesInputFocusedInput", undefined), _defineProperty(_Component$defaultPro, "searchBarDatesInputOnFocusChange", Function.prototype), _defineProperty(_Component$defaultPro, "searchBarDatesInputValue", null), _defineProperty(_Component$defaultPro, "searchBarGetIsDayBlocked", undefined), _defineProperty(_Component$defaultPro, "searchBarGuestsInputLabel", undefined), _defineProperty(_Component$defaultPro, "searchBarGuestsInputValue", null), _defineProperty(_Component$defaultPro, "searchBarLocationInputLabel", undefined), _defineProperty(_Component$defaultPro, "searchBarLocationInputValue", undefined), _defineProperty(_Component$defaultPro, "searchBarLocationOptions", undefined), _defineProperty(_Component$defaultPro, "searchBarMaximumGuestsInputValue", undefined), _defineProperty(_Component$defaultPro, "searchBarModalHeadingText", undefined), _defineProperty(_Component$defaultPro, "searchBarOnChangeInput", undefined), _defineProperty(_Component$defaultPro, "searchBarOnSubmit", Function.prototype), _defineProperty(_Component$defaultPro, "searchBarSearchButton", undefined), _Component$defaultPro);
Component.propTypes = process.env.NODE_ENV !== "production" ? (_ref2 = {
  backgroundImageHeight: oneOfType([string, number]),
  backgroundImageSizes: string,
  backgroundImageSrcSet: string,
  backgroundImageUrl: string.isRequired,
  backgroundImageWidth: oneOfType([string, number]),
  bottomOffset: string,
  className: string,
  currencyNoResultsText: string,
  currencyOptions: arrayOf(shape({
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  currencyValue: oneOfType([bool, number, string]),
  headerLogoHref: string,
  headerLogoSize: oneOf(['medium', 'large', 'huge']),
  headerLogoSizes: string,
  headerLogoSrc: string,
  headerLogoSrcSet: string,
  headerLogoSubText: string,
  headerLogoText: string.isRequired,
  headerNavigationItems: arrayOf(shape({
    href: string,
    subItems: arrayOf(shape({
      href: string.isRequired,
      target: string,
      text: string.isRequired
    })),
    target: string,
    text: string.isRequired
  })).isRequired
}, _defineProperty(_ref2, "headerNavigationItems", arrayOf(shape({
  href: string,
  subItems: arrayOf(shape({
    href: string.isRequired,
    target: string,
    text: string.isRequired
  })),
  target: string,
  text: string.isRequired
})).isRequired), _defineProperty(_ref2, "headerNavigationItems", arrayOf(shape({
  href: string,
  subItems: arrayOf(shape({
    href: string.isRequired,
    target: string,
    text: string.isRequired
  })),
  target: string,
  text: string.isRequired
})).isRequired), _defineProperty(_ref2, "headerPrimaryCTA", shape({
  onClick: func.isRequired,
  text: string.isRequired
})), _defineProperty(_ref2, "headingText", string), _defineProperty(_ref2, "isHeaderBackgroundFilled", bool), _defineProperty(_ref2, "isSearchBarDateRangePickerLoading", bool), _defineProperty(_ref2, "languageOptions", arrayOf(shape({
  text: string.isRequired,
  value: oneOfType([bool, number, string])
}))), _defineProperty(_ref2, "languageValue", oneOfType([bool, number, string])), _defineProperty(_ref2, "onChangeCurrency", func), _defineProperty(_ref2, "onChangeLanguage", func), _defineProperty(_ref2, "phoneNumber", string), _defineProperty(_ref2, "placeholderBackgroundImageUrl", string), _defineProperty(_ref2, "searchBarDateRangePickerLocaleCode", string), _defineProperty(_ref2, "searchBarDatesCheckInLabel", string), _defineProperty(_ref2, "searchBarDatesCheckOutLabel", string), _defineProperty(_ref2, "searchBarDatesInputFocusedInput", oneOf([null, 'startDate', 'endDate'])), _defineProperty(_ref2, "searchBarDatesInputOnFocusChange", func), _defineProperty(_ref2, "searchBarDatesInputValue", shape({
  endDate: object,
  startDate: object
})), _defineProperty(_ref2, "searchBarGetIsDayBlocked", func), _defineProperty(_ref2, "searchBarGuestsInputLabel", string), _defineProperty(_ref2, "searchBarGuestsInputValue", number), _defineProperty(_ref2, "searchBarLocationInputLabel", string), _defineProperty(_ref2, "searchBarLocationInputValue", string), _defineProperty(_ref2, "searchBarLocationOptions", arrayOf(shape({
  indent: oneOf([0, 1, 2, 3, 4, 5]),
  text: string.isRequired,
  value: oneOfType([bool, number, string])
}))), _defineProperty(_ref2, "searchBarMaximumGuestsInputValue", number), _defineProperty(_ref2, "searchBarModalHeadingText", string), _defineProperty(_ref2, "searchBarOnChangeInput", func), _defineProperty(_ref2, "searchBarOnSubmit", func), _defineProperty(_ref2, "searchBarSearchButton", node), _ref2) : {};